import * as React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

export default function CustomizedDialogs(props) {
  const { component, open, setOpen, getactualvalue } = props;

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
        >
          Result
        </BootstrapDialogTitle>
        <DialogContent dividers>
          {component === "audit" ? (
            <Typography gutterBottom>
              {getactualvalue ? getactualvalue : "Loading ..."}
            </Typography>
          ) : component === "remedy" ? (
            <Typography gutterBottom>
              <h4>Before Remedy</h4>
              {window.sessionStorage.getItem("passed_before_fact") === ""
                ? "Actual fact not available"
                : window.sessionStorage.getItem("passed_before_fact")}
              <br />
              <hr />
              <h4>After Remedy</h4>
              {window.sessionStorage.getItem("passed_after_fact") === ""
                ? "Actual fact not available"
                : window.sessionStorage.getItem("passed_after_fact")}
            </Typography>
          ) : component === "rollback" ? (
            <Typography gutterBottom>
              <h4>Before Rollback</h4>
              {sessionStorage.getItem("passed_before_fact") === ""
                ? "Actual fact not available"
                : sessionStorage.getItem("passed_before_fact")}
              <br />
              <hr />
              <h4>After Rollback</h4>
              {sessionStorage.getItem("passed_after_fact") === ""
                ? "Actual fact not available"
                : sessionStorage.getItem("passed_after_fact")}
            </Typography>
          ) : (
            "No Data available ..."
          )}
        </DialogContent>
        <DialogActions>
          <Button variant="contained" autoFocus onClick={handleClose}>
            Close
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
}
